<template>
  <div>
    <Head title="Block Recycle" />
    <h1 class="mb-8 text-3xl font-bold">Recycle</h1>
    <div class="flex items-center justify-between mb-6">
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
      <a
        v-if="recycles.data.length > 0"
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/blocks/recycle/download/${form.dateValue}`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Cutting Date</th>
          <th class="pb-4 pt-6 px-6">Block ID</th>
          <th class="pb-4 pt-6 px-6">Part Number</th>
          <th class="pb-4 pt-6 px-6">Part Description</th>
          <th class="pb-4 pt-6 px-6">Weight</th>
          <th class="pb-4 pt-6 px-6">Line</th>
          <th class="pb-4 pt-6 px-6">User</th>
        </tr>
        <tr
          v-for="block in recycles.data"
          :key="block.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.cutting_date }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.block_ID }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.part_number }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.part_description }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.weight }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.line }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ block.user }}
            </span>
          </td>
        </tr>
        <tr v-if="recycles.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="8">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="recycles.links" />
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    SearchWithDateRange,
    DateRange,
    Pagination
  },
  layout: Layout,
  props: {
    filters: Object,
    recycles: Array,
  },
  data() {
    return {
      form: {
        dateValue: this.filters.dateValue,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/blocks/recycle', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
